import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "./cn"

const panelVariants = cva("rounded-2xl p-4 avex:rounded-avex-md", {
  variants: {
    variant: {
      /** A quieter area inside a section: a group of fields, a sub-form. */
      sunken: "bg-gray-50 avex:bg-surface-sunken",
      /** A card inside a section: one item of a repeated group. */
      outline: "border border-gray-100 avex:border-line",
      /** A place to drop or pick a file. */
      dashed: "border border-dashed border-gray-200 avex:border-line-strong"
    }
  },
  defaultVariants: { variant: "sunken" }
})

/**
 * An area inside a `Section`. The frame of a group within a card is the kit's,
 * like the card itself, so the look of every inner box changes in one place.
 * What goes inside it — a row of fields, a grid — stays with the module.
 */
function Panel({ className, variant, ...props }: React.ComponentProps<"div"> & VariantProps<typeof panelVariants>) {
  return <div data-slot="panel" className={cn(panelVariants({ variant }), className)} {...props} />
}

export { Panel, panelVariants }
